module.exports = __webpack_public_path__ + "static/fipcpastelfloral2-1025f237dfe61beaa90ccd681773c930.jpeg";